export const IsEmptyStr = (str: any) => {
  return !str || str === "";
};

export const IsValidEmailAddress = (address: any) => {
  return address && /\S+@\S+\.\S+/.test(address);
};

export const IsZero = (str: any) => {
  return !str || +str == 0;
};

export const IsNumeric = (str: any, allowEmpty = false) => {
  if (!allowEmpty) return str && /^\d+(\.\d+)?$/.test(str);
  return /^\d+(\.\d+)?$/.test(str);
};

export const IsCurrency = (str: any, allowEmpty = false) => {
  if (!allowEmpty) return !IsEmptyStr(str) && /^\d*\.?\d{0,2}$/.test(str);
  return /^\d*\.?\d{0,2}$/.test(str);
};

export const RemoveSpecialCharacters = (string: string) =>
  string.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "");

// export const RemoveHtmlTag = (string: string) => string?.replace(/<\/?[^>]+(>|$)/g, '');
export const RemoveHtmlTag = (html: string) => {
  // 去除所有 HTML 标签
  const text = html
    ?.replace(/<[^>]+>/g, "") // 去掉标签
    .replace(/&nbsp;/g, " ") // 处理空格实体
    .trim();

  return text;
};
export const isValidAustralianPhoneNumber = (phoneNumber: string) => {
  const pattern = /^(?:\+61|0)[2-478](?:[ -]?[0-9]){8}$/;
  return pattern.test(phoneNumber);
};

export const IsNull = (value: any) => value === null || value === undefined;

export const BuildObservablePatch = <T extends Record<string, any>>(before: T, after: T, keys: (keyof T)[]): Partial<T> => {
  const patch: Partial<T> = {};
  for (const k of keys) {
    if (!Object.is(before?.[k], after?.[k])) patch[k] = after?.[k];
  }
  return patch;
}
export const IsPatchIdentical = (a: any, b: any): boolean => {
  if (Object.is(a, b)) return true;
  if (!a || !b || typeof a !== "object" || typeof b !== "object") return false;

  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) return false;

  for (const k of aKeys) {
    if (!Object.prototype.hasOwnProperty.call(b, k)) return false;
    if (!Object.is(a[k], b[k])) return false;
  }
  return true;
}


export const IsIdenticalObject = (obj1: any, obj2: any) => {
  const getStableStringfy = (obj: any): string => {
    if (obj === null || typeof obj !== "object") return JSON.stringify(obj);
    if (Array.isArray(obj)) return `[${obj.map(getStableStringfy).join(",")}]`;
    const keys = Object.keys(obj).sort();
    return `{${keys.map(k => JSON.stringify(k) + ":" + getStableStringfy(obj[k])).join(",")}}`;
  }
  return getStableStringfy(obj1) === getStableStringfy(obj2);
};